var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo, useRef } from 'react';
import { GlobalModel } from '../../models';
export const useDependencyList = (dependencyList, comparator) => {
    _react_refresh_temp_1();
    const currentDependencyListRef = useRef(dependencyList);
    const updateRef = useRef({});
    if (GlobalModel.hasDependencyListDiff({
        comparator,
        newValue: dependencyList,
        prevValue: currentDependencyListRef.current,
    })) {
        currentDependencyListRef.current = dependencyList;
        updateRef.current = {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Intentional
    return useMemo(() => currentDependencyListRef.current, [updateRef.current]);
};
_react_refresh_temp_1(useDependencyList, "i2cJ69DzIur5G8NWlbrVOnJOG5A=");
